var map = {
	"./avocado_1.svg": 11685,
	"./bacon_1.svg": 10533,
	"./bar_1.svg": 61275,
	"./beans_1.svg": 16311,
	"./beef_1.svg": 6294,
	"./beef_2.svg": 28842,
	"./beef_3.svg": 25940,
	"./beer_1.svg": 15633,
	"./beer_2.svg": 55682,
	"./bottle_1.svg": 57162,
	"./bottle_2.svg": 94457,
	"./bottle_3.svg": 39058,
	"./bread_1.svg": 90017,
	"./bread_2.svg": 18510,
	"./bread_3.svg": 58039,
	"./bread_bag_1.svg": 2927,
	"./breakfast_1.svg": 70480,
	"./breakfast_2.svg": 31289,
	"./breakfast_3.svg": 62373,
	"./breakfast_combo_1.svg": 59897,
	"./bucket_1.svg": 55158,
	"./bucket_2.svg": 57218,
	"./bucket_3.svg": 4705,
	"./buns_1.svg": 83423,
	"./buns_2.svg": 17268,
	"./buns_3.svg": 3142,
	"./burger_1.svg": 79081,
	"./burger_2.svg": 89955,
	"./burger_3.svg": 87850,
	"./burger_4.svg": 15762,
	"./cake_1.svg": 37415,
	"./cake_2.svg": 29406,
	"./cake_3.svg": 88962,
	"./cake_4.svg": 45568,
	"./can_1.svg": 32359,
	"./candy_1.svg": 11649,
	"./candy_2.svg": 61375,
	"./cappuccino_1.svg": 21005,
	"./cereals_1.svg": 5065,
	"./cereals_2.svg": 75144,
	"./cheese_1.svg": 31964,
	"./chicken_1.svg": 5911,
	"./chicken_2.svg": 84426,
	"./chicken_3.svg": 28687,
	"./chicken_4.svg": 84726,
	"./chicken_5.svg": 13281,
	"./chips_1.svg": 31542,
	"./chips_2.svg": 69951,
	"./chips_3.svg": 58997,
	"./chips_4.svg": 30024,
	"./chocolate_1.svg": 42204,
	"./cinnamon_roll_1.svg": 60873,
	"./cocktail_1.svg": 16674,
	"./cocktail_10.svg": 27131,
	"./cocktail_2.svg": 3242,
	"./cocktail_3.svg": 7159,
	"./cocktail_4.svg": 47090,
	"./cocktail_5.svg": 10130,
	"./cocktail_6.svg": 54843,
	"./cocktail_7.svg": 15556,
	"./cocktail_8.svg": 50353,
	"./cocktail_9.svg": 29304,
	"./coffee_1.svg": 41821,
	"./coffee_2.svg": 80448,
	"./coffee_3.svg": 18923,
	"./coke_1.svg": 37215,
	"./cookies_1.svg": 1341,
	"./cookies_2.svg": 68566,
	"./corn_1.svg": 67733,
	"./croissant_1.svg": 34625,
	"./cup_1.svg": 71913,
	"./cup_2.svg": 6384,
	"./cup_3.svg": 77092,
	"./curry_1.svg": 26226,
	"./dessert_1.svg": 51589,
	"./dim_sum_1.svg": 50991,
	"./donut_1.svg": 10872,
	"./donut_2.svg": 38315,
	"./fast_food_1.svg": 35856,
	"./fish_1.svg": 39267,
	"./fish_2.svg": 427,
	"./fries_1.svg": 27848,
	"./gin_tonic_1.svg": 68429,
	"./hot_dog_1.svg": 33292,
	"./hummus_1.svg": 74560,
	"./hummus_2.svg": 33752,
	"./ice_1.svg": 69243,
	"./ice_cream_1.svg": 56149,
	"./ice_cream_2.svg": 53027,
	"./ice_cream_3.svg": 37399,
	"./ice_cream_4.svg": 66634,
	"./ice_cream_5.svg": 41311,
	"./ice_cream_6.svg": 33557,
	"./ice_cream_7.svg": 19965,
	"./ice_cream_8.svg": 43079,
	"./ice_cream_9.svg": 41988,
	"./juice_1.svg": 72471,
	"./juice_2.svg": 84921,
	"./juice_3.svg": 57165,
	"./kebab_1.svg": 67992,
	"./ketchup_1.svg": 78949,
	"./latte_1.svg": 21874,
	"./latte_2.svg": 38461,
	"./lemonade_1.svg": 55180,
	"./mango_1.svg": 79720,
	"./margarita_1.svg": 14970,
	"./martini_1.svg": 58732,
	"./martini_2.svg": 34088,
	"./meatball_1.svg": 70093,
	"./milkshake_1.svg": 16512,
	"./muffin_1.svg": 36165,
	"./mushroom_1.svg": 12154,
	"./nachos_1.svg": 28672,
	"./nachos_2.svg": 54037,
	"./noodles_1.svg": 13785,
	"./noodles_2.svg": 39573,
	"./noodles_3.svg": 51408,
	"./noodles_4.svg": 83529,
	"./nuts_1.svg": 9993,
	"./nuts_2.svg": 48821,
	"./nuts_3.svg": 26395,
	"./oatmeal_1.svg": 75078,
	"./onion_rings_1.svg": 85387,
	"./paella_1.svg": 12228,
	"./pancakes_1.svg": 28997,
	"./pancakes_2.svg": 75282,
	"./pasta_1.svg": 29892,
	"./pie_1.svg": 69085,
	"./pizza_1.svg": 52052,
	"./pizza_2.svg": 59534,
	"./popcorn_1.svg": 92320,
	"./pretzel_1.svg": 49058,
	"./quesadilla_1.svg": 74773,
	"./ramen_1.svg": 79079,
	"./ribs_1.svg": 44727,
	"./rice_1.svg": 85061,
	"./rice_2.svg": 17863,
	"./rice_3.svg": 20150,
	"./rice_4.svg": 13233,
	"./salad_1.svg": 87732,
	"./salad_2.svg": 41776,
	"./salad_3.svg": 57805,
	"./salad_4.svg": 96112,
	"./salad_5.svg": 17669,
	"./salad_6.svg": 82974,
	"./salad_7.svg": 8905,
	"./salad_combo_1.svg": 97673,
	"./sandwich_1.svg": 16314,
	"./sandwich_2.svg": 32650,
	"./sandwich_3.svg": 20477,
	"./sandwich_4.svg": 26906,
	"./sandwich_5.svg": 67169,
	"./sangria_1.svg": 33951,
	"./sauce_1.svg": 94091,
	"./sauce_2.svg": 59947,
	"./sauce_3.svg": 65335,
	"./sausage_1.svg": 98721,
	"./sausage_2.svg": 82965,
	"./shashlik_1.svg": 63968,
	"./shot_1.svg": 29111,
	"./shot_2.svg": 12547,
	"./smoothie_1.svg": 41727,
	"./smoothie_2.svg": 59431,
	"./smoothie_3.svg": 73734,
	"./smoothie_4.svg": 9079,
	"./soup_1.svg": 30982,
	"./soup_2.svg": 90903,
	"./soup_3.svg": 90437,
	"./soup_4.svg": 28649,
	"./soup_5.svg": 725,
	"./soup_6.svg": 71446,
	"./soup_7.svg": 20357,
	"./stew_1.svg": 95992,
	"./sushi_1.svg": 58554,
	"./sushi_2.svg": 67882,
	"./sushi_3.svg": 12192,
	"./taco_1.svg": 37118,
	"./tea_1.svg": 33709,
	"./tea_2.svg": 23555,
	"./tea_3.svg": 77996,
	"./tea_4.svg": 20584,
	"./tequila_1.svg": 84932,
	"./ticket_1.svg": 32031,
	"./ticket_2.svg": 47717,
	"./toast_1.svg": 82516,
	"./tofu_1.svg": 40561,
	"./tofu_2.svg": 18866,
	"./tofu_3.svg": 25956,
	"./waffle_1.svg": 58261,
	"./wine_1.svg": 39948,
	"./wine_2.svg": 99505,
	"./wine_bottle_1.svg": 39863,
	"./wine_bottle_2.svg": 36947,
	"./wine_bottle_3.svg": 89559,
	"./wrap_1.svg": 74369,
	"./wrap_2.svg": 57356,
	"./yogurt_1.svg": 39860,
	"./yogurt_2.svg": 81616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62370;